import { buildApiUrl } from "../../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ReclutamientoAdmin.css";
import { PostulanteService } from "../../services/PostulanteService";
import { Pencil, Phone, View } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Permiso from "../../router/Permiso";
import ModalContactar from "./ModalContactar";
import { toast } from "react-toastify";
import ModalViewPostulante from "./ModalViewPostulante";

const ListadoPostulantes = ({ token, onRefresh, estados }) => {
  const navigate = useNavigate();
  const [postulantes, setPostulantes] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [buscarNombre, setBuscarNombre] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [errors, setErrors] = useState({});
  const [showContactarModal, setShowContactarModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [postulanteSeleccionado, setPostulanteSeleccionado] = useState(null);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [formData, setFormData] = useState({
    comentario_contacto: "",
    estado_postulante: "",
    fecha_cita: "",
  });

  useEffect(() => {
    fetchPostulantes();
  }, [filtroEstado, currentPage, buscarNombre, fechaInicio, fechaFin]);

  const fetchPostulantes = async () => {
    setLoading(true);
    setError("");
    try {
      const { postulantes, totalPages, totalRegistros } = await PostulanteService.fetchPostulantes({
        token,
        desde: fechaInicio,
        hasta: fechaFin,
        nombre: buscarNombre,
        estado: filtroEstado,
        order: 'fecha_created',
        page: currentPage,
        limit: 20,
      });

      setPostulantes(postulantes);
      setTotalPages(totalPages);
      setTotalRegistros(totalRegistros);
    } catch (err) {
      setError("Error al cargar postulantes");
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const validarContacto = () => {
    const errores = {};

    if (!formData.comentario_contacto.trim()) {
      errores.comentario_contacto = 'El comentario es obligatorio';
    }

    if (!formData.estado_postulante) {
      errores.estado_postulante = 'El estado del postulante es obligatorio';
    }

    if (formData.estado_postulante == "2" && !formData.fecha_cita.trim()) {
      errores.fecha_cita = 'La fecha de la cita es obligatoria';
    }

    return errores;
  };


  const handleContactar = (postulante) => {
    setPostulanteSeleccionado(postulante);
    setFormData({
      comentario_contacto: "",
      estado_postulante: postulante.id_estado_postulante,
      fecha_cita: "",
    });
    setShowContactarModal(true);
  };

  const handleViewPostulante = (postulante) => {
    setPostulanteSeleccionado(postulante);
    setShowViewModal(true);
  };

  const handleSubmitContactar = async (e) => {
    e.preventDefault();

    const errores = validarContacto();

    if (Object.keys(errores).length > 0) {
      setErrors(errores);
      return;
    }
    try {
      await PostulanteService.contactarPostulante(
        token,
        postulanteSeleccionado.id,
        formData
      );

      setShowContactarModal(false);
      fetchPostulantes();

      if (formData.estado_postulante == "2" && onRefresh) {
        onRefresh();
      }

      toast.success("Postulante contactado exitosamente");
    } catch (err) {
      toast.error("Error al contactar postulante");
      console.error("Error:", err);
    }
  };

  const handleUpdatePostulante = async (post) => {
    navigate(`/admin/reclutamiento/${post.id}`);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === 'estado_postulante' ? Number(value) : value,
    }));
  };

  const getEstadoClass = (estado) => {
    switch (estado) {
      case "Contactar":
        return "estado-contactado";
      case "Citado":
        return "estado-citado";
      case "No desea":
        return "estado-entrevistado";
      case "No cumple perfil":
        return "estado-contratado";
      case "Contratado":
        return "estado-rechazado";
      default:
        return "estado-pendiente";
    }
  };

  return (
    <div className="usuarios-table-container">
      <div className="usuarios-table-header">
        <h2 className="usuarios-table-title">Listado de Postulantes</h2>
      </div>
      <div className="usuarios-filtros">

        <div className="filtro-grupo">
          <label>Fecha Inicio:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
          />
        </div>
        <div className="filtro-grupo">
          <label>Fecha Fin:</label>
          <input
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
          />
        </div>
        <div className="filtro-item">
          <label>Buscar por Nombre:</label>
          <input
            type="text"
            value={buscarNombre}
            onChange={(e) => setBuscarNombre(e.target.value)}
            placeholder="Nombre, apellido o nombre completo"
          />
        </div>
        <div className="filtro-grupo">
          <label>ESTADO POSTULANTE:</label>
          <select
            id="filtroEstado"
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
            className="filtro-select"
          >
            <option value="">Todos los estados</option>
            {estados.map((estado) => (
              <option key={estado.id} value={estado.id}>
                {estado.descripcion}
              </option>
            ))}
          </select>
        </div>
        <div className="filtro-grupo">
          <button
            onClick={() => {
              setFechaInicio("");
              setFechaFin("");
              setBuscarNombre("");

              fetchPostulantes();
            }}
            className="btn-limpiar"
          >
            Limpiar Filtros
          </button>
        </div>

      </div>

      <div className="ventas-table-wrapper">
        <table className="ventas-table">
          <thead>
            <tr>
              <th>Tipo Postulación</th>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Referido Por</th>
              <th>Estado</th>
              <th>Fecha Solicitud</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  Cargando...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  {error}
                </td>
              </tr>
            ) : postulantes.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  No hay postulantes registrados
                </td>
              </tr>
            ) : (
              postulantes.map((post) => (
                <tr key={post.id} className="producto-row">
                  <td>{post.descripcion_postulacion || "-"}</td>
                  <td>{post.nombre ? post.nombre + " " + post.apellidoPaterno + " " + post.apellidoMaterno : post.nombre_referido || "-"}</td>
                  <td>{post.telefono || "-"}</td>
                  <td>{post.nombre_usuario} {post.apellido_usuario}</td>
                  <td>
                    <span
                      className={`estado-postulante ${getEstadoClass(
                        post.estado_postulacion
                      )}`}
                    >
                      {post.estado_postulacion || "-"}
                    </span>
                  </td>
                  <td>
                    {post.fecha_created
                      ? new Date(post.fecha_created).toLocaleString('es-PE', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: true // 👈 esto activa el formato AM/PM
                      })
                      : "-"}
                  </td>
                  <td className="ventas-acciones">
                    <Permiso permiso="recruitment_view">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleViewPostulante(post)}
                      >
                        <View size={18} />
                      </span>
                    </Permiso>
                    <Permiso permiso="recruitment_contactar">
                      {post.estado_postulacion === "Contactar" && (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => handleContactar(post)}
                        >
                          <Phone size={18} />
                        </span>
                      )}
                    </Permiso>
                    <Permiso permiso="recruitment_edit">
                      {post.estado_postulacion === "Contactar" && (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => handleUpdatePostulante(post)}
                        >
                          <Pencil size={20} />
                        </span>
                      )}
                    </Permiso>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
        {" "}
        Total de registros: {totalRegistros}{" "}
      </span>
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Anterior
        </button>
        <span>
          Página {currentPage} de {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Siguiente
        </button>
      </div>
      {showViewModal && postulanteSeleccionado && (
        <ModalViewPostulante
          postulante={postulanteSeleccionado}
          onClose={() => setShowViewModal(false)}
        />
      )}

      {/* Modal de Contactar Mejorado */}
      {showContactarModal && postulanteSeleccionado && (
        <ModalContactar
          show={showContactarModal}
          postulante={postulanteSeleccionado}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmitContactar}
          estados={estados}
          errors={errors}
          onClose={() => setShowContactarModal(false)}
        />
      )}
    </div>
  );
};

export default ListadoPostulantes;
